import ContentBanner from './ContentBanner'

const ContentBannerSection = ({ props }) => {
  const { background, image, imageFile, text, title } = props
  return (
    <section
      style={{
        backgroundImage: `url(${background.fields.file.url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
      aria-label={title}
    >
      <ContentBanner title={title} text={text} imageSrc={image} imageFile={imageFile} />
    </section>
  )
}

export default ContentBannerSection
